export default {
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '50px',
  },
  stimul: {
    fontSize: '15px',
    fontWeight: '900',
  },
  flowTitle: {
    marginRight: '20px',
  },
  permanentCheckbox: {
    height: '24px',
  },
};
